import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 20C16.97 20 21 16.418 21 12C21 7.582 16.97 4 12 4C7.03 4 3 7.582 3 12C3 13.574 3.512 15.042 4.395 16.28L3 20L7.745 19.051C9.07479 19.6808 10.5286 20.005 12 20Z",
			stroke: "#1E293B",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1358 14.65C12.1334 14.65 12.1309 14.65 12.1285 14.65C11.6838 14.6461 11.3261 14.2979 11.3301 13.8717L11.3337 13.486C11.3337 13.464 11.3349 13.4417 11.3374 13.4197C11.4489 12.2977 12.2268 11.6101 12.8524 11.0574C13.0643 10.8699 13.2649 10.6929 13.4357 10.5082C13.644 10.2833 13.9461 9.82282 13.6283 9.26705C13.2621 8.62528 12.3678 8.44362 11.6729 8.59597C10.947 8.75487 10.6795 9.34843 10.5845 9.68783C10.4692 10.0994 10.0273 10.3435 9.59752 10.2336C9.1677 10.1233 8.9127 9.70017 9.02751 9.28865C9.34857 8.14048 10.1816 7.34019 11.3128 7.0922C12.8351 6.75936 14.3683 7.34829 15.0414 8.52655C15.6017 9.50772 15.4483 10.659 14.6406 11.5314C14.4162 11.7736 14.1765 11.9857 13.9445 12.1905C13.3664 12.7015 13.0051 13.0433 12.9439 13.5365L12.9406 13.8848C12.9374 14.3094 12.5773 14.65 12.1358 14.65Z",
			fill: "#1E293B",
			stroke: "#1E293B",
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1843 17.2C11.9764 17.2 11.7686 17.116 11.6206 16.9681C11.4687 16.8202 11.3848 16.6123 11.3848 16.4004C11.3848 16.1925 11.4687 15.9847 11.6206 15.8367C11.9165 15.5409 12.4522 15.5409 12.748 15.8367C12.8999 15.9847 12.9839 16.1925 12.9839 16.4004C12.9839 16.6123 12.8999 16.8162 12.752 16.9681C12.6001 17.116 12.3962 17.2 12.1843 17.2Z",
			fill: "#1E293B",
			stroke: "#1E293B",
			strokeWidth: .3
		})
	]
});
export default SvgHelp;
